import apiClient from "./client";
import { getAnon, getGuestId } from "../utils/localStorage";
import { clearSharedAuth, persistSharedAuth } from "../utils/sharedAuth";

function withGuestId(data = {}) {
  const guestId = getGuestId();
  const anon = getAnon();

  return {
    ...data,
    ...(guestId ? { guest_id: guestId } : {}),
    ...(anon?.uuid ? { anon_uuid: anon.uuid } : {}),
  };
}

const AuthService = {
  getGoogleConfig: async () => {
    const response = await apiClient.get("auth/google-config/");
    return response.data;
  },

  // 🔹 Inscription
  register: async (data) => {
    const response = await apiClient.post("auth/register/", withGuestId(data));
    return response.data;
  },

  // 🔹 Connexion
  login: async (data) => {
    const response = await apiClient.post("auth/login/", withGuestId(data));
    if (response.data.access && response.data.refresh) {
      persistSharedAuth({
        access: response.data.access,
        refresh: response.data.refresh,
        user: response.data.user || null,
      });
    }
    return response.data;
  },

  loginWithGoogle: async (credential) => {
    const response = await apiClient.post(
      "auth/google-login/",
      withGuestId({ credential })
    );
    if (response.data.access && response.data.refresh) {
      persistSharedAuth({
        access: response.data.access,
        refresh: response.data.refresh,
        user: response.data.user || null,
      });
    }
    return response.data;
  },

  // 🔹 Déconnexion
  logout: () => {
    clearSharedAuth();
  },

  // 🔹 Mot de passe oublié
  forgotPassword: async (email) => {
    const response = await apiClient.post("auth/forgot-password/", { email });
    return response.data;
  },

  // 🔹 Réinitialiser le mot de passe
  resendVerification: async (email) => {
    const response = await apiClient.post("auth/resend-verification/", {
      email,
    });
    return response.data;
  },
  resetPassword: async (data) => {
  const response = await apiClient.post("auth/reset-password/", data);
  return response.data;
},
  changePassword: async (data) => {
    const response = await apiClient.post("auth/change-password/", data);
    return response.data;
  },
};

export default AuthService;
